import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import WGCornmealProduct from 'models/WGCornmealProduct'
import WGCornmealPackage from './WGCornmealPackage'

const productOptions = {
  packagingInfo: <WGCornmealPackage />,
  productTitle: 'Whole Grain Cornmeal',
  model: WGCornmealProduct,
  validCategories: ['16'],
  validSubCategories: ['017'],
}

const WGCornmeal = () => <ProductForm product={productOptions} />

export default WGCornmeal
